import React from 'react';
import PropTypes from 'prop-types';

const DemoRequestCard = ({
  icon,
  title,
  description,
  className = '',
  iconClassName = '',
  titleClassName = '',
  descriptionClassName = '',
  ...props
}) => {
  return (
    <div 
      className={`bg-[#f3f8ff] rounded-2xl p-6 ${className}`}
      {...props}
    >
      {icon && (
        <div className={`mb-12 ${iconClassName}`}>
          {icon}
        </div>
      )}
      
      {title && (
        <h3 className={`text-xl font-semibold text-[#121725] mb-2 ${titleClassName}`}>
          {title}
        </h3>
      )}
      
      {description && (
        <p className={`text-base text-[#202a44] ${descriptionClassName}`}>
          {description}
        </p>
      )}
    </div>
  );
};

DemoRequestCard.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  descriptionClassName: PropTypes.string
};

export default DemoRequestCard;